import { moduleName as parentModuleName } from '../constants';

export const moduleName = 'searchDenChief';
export const modulePath = [parentModuleName, moduleName];
